import { render } from "./ManageCampaignTemplates.vue?vue&type=template&id=7bcf0094"
import script from "./ManageCampaignTemplates.vue?vue&type=script&lang=js"
export * from "./ManageCampaignTemplates.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__